import * as React from 'react';

import {ChevronRightIcon} from 'shells/icon';

import type {Flow} from 'flow-to-typescript-codemod';

import {colors} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import {LoadingText} from '../loading-placeholder/loading-text';
import {StatusBadge} from '../status-badge/status-badge';
import type {StatusBadgeProps} from '../status-badge/status-badge';
import {Body} from '../typography/body';

import {Card} from './card';
import type {CardProps} from './card';

import styles from './feature-status-card.module.css';

export type Props = {
    icon: React.ComponentType<any>;
    iconFill?: string;
    title: string;
    subtitle: React.ReactNode;
    tertiaryData?: React.ReactNode;
    statusBadge: StatusBadgeProps | null | undefined; // null means loading,
    banner?: React.ReactNode;
} & Flow.Diff<
    CardProps,
    {
        hasBorder: boolean;
        fitContent: boolean;
        fitHeight: boolean;
        children: React.ReactNode;
    }
>;

export function FeatureStatusCard(props: Props) {
    const {
        icon: Icon,
        iconFill,
        title,
        subtitle,
        tertiaryData,
        statusBadge,
        banner,
        ...restProps
    } = props;

    return (
        <Card {...restProps} hasBorder={true} fitContent={false} fitHeight={true} hasShadow={true}>
            <div className='flex'>
                <div className={styles['icon-style']}>
                    <Icon fill={iconFill || colors.greyLt} size={24} />
                </div>
                <div className='flex flex-dir-col py-16 full-width gap-8'>
                    <StackLegacy spacing={4}>
                        <Body isBold={true} color='dark'>
                            {title}
                        </Body>
                        {subtitle}
                        {tertiaryData}
                    </StackLegacy>
                    {banner}
                </div>
                <div className='flex flex-shrink align-center justify-end px-32 gap-16'>
                    {statusBadge ? (
                        <StatusBadge {...statusBadge} size='small' />
                    ) : (
                        <div className='br-3 border'>
                            <LoadingText width={75} height={17} />
                        </div>
                    )}
                    {restProps.onClick && (
                        <ChevronRightIcon size={16} className={styles['chevron-style']} />
                    )}
                </div>
            </div>
        </Card>
    );
}
